import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { headersBase, headersType } from "../../../utils/constants/headersForApi";

export const notificheApi = createApi({
  reducerPath: "notifiche",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["notifiche"],
  endpoints: (builder) => ({
    getNotifiche: builder.query({
      query: ({ studioId }) => ({
        url: `/admin/push/schedules?studioId=${studioId}`,
        method: "GET",
        headers: headersBase()
      }),
      providesTags: ["notifiche"],
    }),
    createNotifica: builder.mutation({
      query: (service) => ({
        url: `/admin/push/schedules`,
        method: "POST",
        headers: headersType(),
        body: service,
      }),
      invalidatesTags: ["notifiche"],
    }),
    deleteNotifica: builder.mutation({
      query: ({ id }) => ({
        url: `/admin/push/schedules/${id}`,
        method: "DELETE",
        headers: headersBase(),
        body: { id },
      }),
      invalidatesTags: ["notifiche"],
    }),
    editNotifica: builder.mutation({
      query: (notifica) => ({
        url: `/admin/push/schedules/${notifica.id}`,
        method: "PUT",
        headers: headersType(),
        body: notifica,
      }),
      invalidatesTags: ["notifiche"],
    }),
  }),
});

export const {
  useGetNotificheQuery,
  useCreateNotificaMutation,
  useEditNotificaMutation,
  useDeleteNotificaMutation,
} = notificheApi;
